import styled from "styled-components";

const ConcreteStyled = styled.div`
  
`;

export { ConcreteStyled };
